/**
 * VK на Android держит мини-приложение под системными панелями и присылает их высоту
 * событием VKWebAppUpdateConfig/VKWebAppUpdateInsets. Подписка живёт в index.html
 * (vkBridge подключается там же, и событие приходит раньше, чем стартует Vue),
 * сюда значения попадают через window.__vkView.
 *
 * Без вычитания нижнего инсета панель героев рисуется под панелью навигации - ровно
 * жалоба «не видно героев, чёрная полоса снизу».
 */
export default class VkInsets {

    /** Системная панель не занимает больше 15% высоты экрана - иначе число не в CSS-пикселях. */
    private static readonly MAX_SHARE: number = 0.15;

    /** Высота нижней системной панели в CSS-пикселях; 0, если VK ничего не прислал. */
    public static getBottomCss(viewportHeight: number): number {
        return VkInsets.toCss(VkInsets.raw('bottom'), viewportHeight);
    }

    /** Сырой ответ VK для диагностических логов. */
    public static describe(): string {
        const view = VkInsets.view();
        if (!view) {
            return 'none';
        }
        try {
            return JSON.stringify(view);
        } catch (e) {
            return 'unreadable';
        }
    }

    private static view(): any {
        try {
            // @ts-ignore
            return window.__vkView;
        } catch (e) {
            return undefined;
        }
    }

    private static raw(side: string): number {
        const view = VkInsets.view();
        const value = view && view.insets ? view.insets[side] : undefined;
        return typeof value === 'number' && isFinite(value) && value > 0 ? value : 0;
    }

    /**
     * Инсеты приходят в физических пикселях (VKUI делит их на devicePixelRatio), но не на
     * всех клиентах: если число и так укладывается в разумную долю экрана, оно уже в CSS.
     * Явно неправдоподобное значение игнорируем - лучше оставить как есть, чем срезать пол-экрана.
     */
    private static toCss(raw: number, viewportHeight: number): number {
        if (raw <= 0 || viewportHeight <= 0) {
            return 0;
        }
        const limit = viewportHeight * VkInsets.MAX_SHARE;
        const dpr = window.devicePixelRatio || 1;
        const value = raw > limit ? raw / dpr : raw;
        return value > limit ? 0 : Math.round(value);
    }
}
